export default "/_next/static/images/feature-checkmark-3c4cdaad268409bfb36583867cb003dc.svg";